<template>
  <!--
    O AVISO DE EVENTO DO MUNDO, em papel (D28/D15). Era o modal azul com 🎣 e 🐟 de enfeite; virou
    o mesmo bilhete dos eventos da agenda: a paisagem do evento com a cor do TIPO na barra de
    baixo (bom/ruim/neutro — semântica na borda, papel no corpo, D0), e o botão com a fala do
    pescador, que era a melhor coisa do modal antigo e ficou.
  -->
  <FishModal v-if="event" :aberto="true" :titulo="$t(`events.${event.name}.name`)" @fechar="$emit('close')">
    <div class="evento" :class="`evento--${event.typeEvent}`">
      <img class="evento__arte" :src="eventImage" :alt="''" aria-hidden="true">

      <p class="evento__descricao">{{ $t(`events.${event.name}.description`) }}</p>

      <p class="evento__duracao">
        <FishIcon nome="clock" tamanho="pequeno" />
        {{ $t('duration') }}: {{ event.days }} {{ $t('days') }}
      </p>
    </div>

    <template #acoes>
      <FishButton variante="primario" bloco som="clique" @click="handleEventResponse">
        {{ buttonText }}
      </FishButton>
    </template>
  </FishModal>
</template>

<script>
import { getItemImage } from '@/shared/utils/eventImages';
import { FishModal, FishButton, FishIcon } from '@/shared/ui';

export default {
  name: 'EventModal',
  components: { FishModal, FishButton, FishIcon },
  emits: ['close'],
  data() {
    return {
      event: null
    }
  },
  computed: {
    eventImage() {
      return this.event ? getItemImage(this.event.name) : '';
    },
    buttonText() {
      if (!this.event?.typeEvent) return this.$t('buttonText.default');

      const messages = {
        good: [
          this.$t('buttonText.good1'),
          this.$t('buttonText.good2'),
          this.$t('buttonText.good3'),
          this.$t('buttonText.good4'),
          this.$t('buttonText.good5'),
          this.$t('buttonText.good6')
        ],
        bad: [
          this.$t('buttonText.bad1'),
          this.$t('buttonText.bad2'),
          this.$t('buttonText.bad3'),
          this.$t('buttonText.bad4'),
          this.$t('buttonText.bad5'),
          this.$t('buttonText.bad6')
        ],
        neutral: [
          this.$t('buttonText.neutral1'),
          this.$t('buttonText.neutral2'),
          this.$t('buttonText.neutral3'),
          this.$t('buttonText.neutral4'),
          this.$t('buttonText.neutral5'),
          this.$t('buttonText.neutral6')
        ]
      };

      const typeMessages = messages[this.event.typeEvent];
      const randomIndex = Math.floor(Math.random() * typeMessages.length);
      return typeMessages[randomIndex];
    }
  },
  methods: {
    async fetchLatestEvent() {
      // A action fala com o V2 e devolve `{ event }` — evento real, com
      // `name`, `typeEvent` e `days` calculados no adapter — ou `event: null`
      // quando nunca houve evento, e aí o modal simplesmente não renderiza
      // (o template tem `v-if="event"`).
      try {
        const response = await this.$store.dispatch('events/fetchLastEvent');
        if (response.event) {
          this.event = response.event;
        }
      } catch (error) {
        console.error(
          'Error fetching event:',
          error.response?.data?.message || error.response?.data?.error?.message || error.message
        );
      }
    },
    // `fetchAllEvents` saiu: batia em `/api/events` do Strapi, que não existe
    // no V2, e ninguém consumia a resposta — era um GET jogado fora.
    handleEventResponse() {
      this.$emit('close');
    }
  },
  created() {
    this.fetchLatestEvent();
  }
}
</script>

<style scoped>
.evento {
  display: flex;
  flex-direction: column;
  gap: var(--e-3);
}

/* A cor do tipo fica na barra de baixo da arte — a mesma regra da agenda do caderno (D0). */
.evento__arte {
  width: 100%;
  max-height: 180px;
  object-fit: cover;
  image-rendering: auto;
  border: 3px solid var(--madeira);
  border-bottom: 5px solid var(--cor-neutra);
}

.evento--good .evento__arte {
  border-bottom-color: var(--cor-bom);
}

.evento--bad .evento__arte {
  border-bottom-color: var(--cor-ruim);
}

.evento__descricao {
  margin: 0;
  font-size: var(--f-2);
  color: var(--tinta);
  line-height: var(--lh-normal);
}

.evento__duracao {
  margin: 0;
  display: flex;
  align-items: center;
  gap: var(--e-1);
  font-size: var(--f-1);
  color: var(--tinta-fraca);
}
</style>
